export const lottieAnimations = {
    onTheWay: require('../../assets/lottie/ontheway.json'),
    noService: require('../../assets/lottie/noservice.json'),
    findLocation: require('../../assets/lottie/findLocation.json'),
    restrictedzone: require('../../assets/lottie/restrictedzone.json'),
    radarsearch: require('../../assets/lottie/radarsearch.json'),
    cancelTrip: require('../../assets/lottie/cancelTrip.json'),
    paymentDone: require('../../assets/lottie/paymentDone.json'),
    pickup: require('../../assets/lottie/pickup.json'),
    tripCompleted: require('../../assets/lottie/tripCompleted.json'),
    celebration1: require('../../assets/lottie/celebration1.json'),
    celebration2: require('../../assets/lottie/celebration2.json'),
    loadingDotsRound: require('../../assets/lottie/LoadingDotsRound.json'),
    success: require('../../assets/lottie/success.json'),
    failure: require('../../assets/lottie/failure.json'),
  };